import variables from "@/config/variables";
export const APP_NAME = "ReFlowConnect";
export const CORE_SERVICE_BASE_URL = variables.CORE_SERVICE_BASE_URL;
export const WE_AID_SERVICE_BASE_URL = variables.WE_AID_SERVICE_BASE_URL;
export const MEDIA_MART_BASE_URL = variables.MEDIA_MART_BASE_URL;
export const MIRAKL_WEBSHOP_SEARCH_BASE_URL =
  variables.MIRAKL_WEBSHOP_SEARCH_BASE_URL;
export const EBAY_LISTING_BASE_URL = variables.EBAY_LISTING_BASE_URL;
export const EBAY_LISTED_ITEM_BASE_URL = variables.EBAY_LISTED_ITEM_BASE_URL;
export const SAND_BOX_EBAY_BASE_URL = variables.SAND_BOX_EBAY_BASE_URL;
export const SUPPORT_URLS = {
  SHAREPOINT:
    "https://mediasaturn.sharepoint.com/sites/DEU-Store-Processes/SitePages/ReFlow-Connect.aspx",
};

export const SUPPORT_PHONES = {
  EBAY_CONCIERGE: "033203 851021",
  EBAY_ACCOUNT: "033203 851310",
};

export const SUPPORT_EMAILS = {
  TECHNICAL: "it.reflowconnect@i-ways.net",
  MMSD_STORE_PROCESSES: "mmsd.store.processes@mediamarktsaturn.de",
  EBAY_CONCIERGE: "customerhelp_de@ebay.com",
  EBAY_ACCOUNT: "msd@ebay.de",
  MIRAKL: "mms.partner.de@mms-marketplace.com",
};

export const MARKET_PLACES = {
  EBAY: "eBay",
  MIRAKL: "Mirakl",
};

export const MARKETPLACE_LOGOS = {
  EBAY: "/assets/ebaylogo.png",
  MIRAKL: "/assets/mirakl-logo.png",
};
export const MARKETPLACE_IDS = {
  EBAY: "ebay",
  MIRAKL: "mirakl",
  EBAY_MIRAKL: "ebay-mirakl",
  ALL: "all",
};

// backend's equal-match values for the marketplace/marketplaceId filter field
export const MARKETPLACE_FILTER_VALUES = {
  EBAY: "EBAY",
  MIRAKL: "MIRAKL",
  ALL: "ALL",
};

export const MARKETPLACE_FILTER_OPTIONS = [
  { label: MARKET_PLACES.EBAY, value: MARKETPLACE_FILTER_VALUES.EBAY },
  { label: MARKET_PLACES.MIRAKL, value: MARKETPLACE_FILTER_VALUES.MIRAKL },
];

export const MIRAKL_LISTING_STATUS = {
  PENDING: "PENDING",
};

export const MIRAKL_OFFER_OPERATION_TOOLTIP_KEYS = {
  CREATE: "miraklOperationCreate",
  UPDATE: "miraklOperationUpdate",
  DELETE: "miraklOperationDelete",
};

export const SHIPPING_HANDLING_TYPES = {
  TWO_MH: "TWO_MH",
  PARCEL: "PARCEL",
  NULL: null,
};
export const APP_STORE_SLICES = {
  BULK_UPLOAD: {
    OFFER_DETAILS: "bulkUploadOfferDetails",
  },
  EASY_LISTER: {
    ARTICLE_LISTING: "articleListing",
  },
};
export const SCOPE_OF_DELIVERY_MAX_LENGTH = 65;
export const CONDITION_DESCRIPTION_MAX_LENGTH = 250;
export const EBAY_TITLE_MAX_LENGTH = 80;
export const PROCESSING_TIME_MAX_LIMIT = 20;
export const DEFAULT_EBAY_CONDITION_ID = 1000;
export const CONDITION_ID_MAP = {
  Neu: {
    idField: "conditionIDNeu",
    nameField: "conditionNeu",
  },
  "Neu Sonstiges": {
    idField: "conditionIDNeuSonstige",
    nameField: "conditionNeuSonstige",
  },
  Gebraucht: {
    idField: "conditionIDGebraucht",
    nameField: "conditionGebraucht",
  },
};
export const EBAY_ITEM_CONDITION = {
  NEW: "Neu",
  REFURBISHED: "Refurbished",
  PACKAGE_DAMAGED: "Verpackung beschädigt",
};
export const SHIPPING_TYPES = {
  DHL_SHIPPING: "DHL Versandkosten",
  SPEDITON_SHIPPING: "Speditons-Versandkosten",
};

export const TABLE_IDS = {
  ERROR_LOGS: "ERROR_LOGS_TABLE",
  ORDER_LISTING: "ORDER_LISTING_TABLE",
  OUTLET_LISTING: "OUTLET_LISTING_TABLE",
  RANKING_LISTING: "RANKING_LISTING_TABLE",
  FAILED_MIRAKL_LISTINGS: "FAILED_MIRAKL_LISTINGS_TABLE",
};
export const CONDITION_DESCRIPTION = {
  NEW: "Der Artikel ist neu und originalverpackt",
};
export const DATA_TYPES = {
  STRING: "string",
  OBJECT: "object",
};
export const PRODUCT_ASSET_TYPE = {
  MANUFACTURER_IMAGE: "Manufacturer Image",
  PRODUCT_IMAGE: "Product Image",
  FEATURE_ASSET: "Feature Asset",
};

export const ARTICLE_LISTING_IMAGE_TYPES = {
  PRODUCT_IMAGE: "Product Image",
  PRODUCT_IMAGE_LEGACY: "Product image",
  EXTERNAL_IMAGE: "External image",
  LIFESTYLE_IMAGE: "Lifestyle Image",
  LIFESTYLE_IMAGE_LEGACY: "lifestyleimage",
};

export const STORAGE_KEYS = {
  AUTH_STORAGE: "auth-storage",
};
export const USER_ROLES = {
  SUPER_USER: "superUser",
  SELLER: "seller",
};
export const ROUTE_ROLES = {
  SETTINGS: [USER_ROLES.SUPER_USER],
};

export const AUTH_GUARD_STATUS = {
  CHECKING: "checking",
  AUTHENTICATED: "authenticated",
};

// Sub-routes directly under /listings.
export const LISTING_SUB_ROUTES = {
  OVERVIEW: "overview",
  ERROR_LOGS: "error-logs",
  FAILED_MIRAKL_LISTINGS: "failed-mirakl-listings",
};

// Super admin has read-only listing access: only the overview table, the
// error logs, and the failed Mirakl listings table. Everything else under
// /listings (Easy Lister search, bulk upload, item-edit screens) is blocked
// and redirected home by the auth guard.
export const SUPER_ADMIN_ALLOWED_LISTING_SUB_ROUTES = [
  LISTING_SUB_ROUTES.OVERVIEW,
  LISTING_SUB_ROUTES.ERROR_LOGS,
  LISTING_SUB_ROUTES.FAILED_MIRAKL_LISTINGS,
];

export const OPERATIONS_SECURITY_GROUP_ID =
  "sg_germany_reflow_connect_operations";
export const ACCOUNTING_SECURITY_GROUP_ID =
  "sg_germany_reflow_connect_accounting";
export const ADMINISTRATOR_SECURITY_GROUP_ID =
  "sg_germany_reflow_connect_administrator";
// Super-admin users in this group (MSH reporting-only staff) may use the backend
// solely for reporting: only the Reporting (Statistics) tab is shown and every
// other route is redirected there. Added 2026-09-03 per client request.
export const REPORTING_SECURITY_GROUP_ID =
  "sg_germany_reflow_connect_reporting";
// Not handled by the frontend yet — shown disabled in the security-group picker
// with a "no access" hover message. Do NOT add to SUPPORTED_SECURITY_GROUP_IDS
// until the intended behaviour for this group is implemented.
export const STORE_MANAGER_SECURITY_GROUP_ID =
  "sg_germany_reflow_connect_store_manager";

// Prefix shared by every reflow-connect super-admin security group.
export const REFLOW_CONNECT_SG_PREFIX = "sg_germany_reflow_connect_";

// Reflow-connect super-admin security groups the frontend explicitly handles.
// A reflow-connect group NOT in this list is treated as unhandled: the security-group
// picker shows it disabled and blocks continuing with it.
export const SUPPORTED_SECURITY_GROUP_IDS = [
  ADMINISTRATOR_SECURITY_GROUP_ID,
  ACCOUNTING_SECURITY_GROUP_ID,
  OPERATIONS_SECURITY_GROUP_ID,
  REPORTING_SECURITY_GROUP_ID,
];

// True for a reflow-connect super-admin security group that the frontend does not
// yet support (e.g. a newly created SG-Group the client rolled out on the backend).
export const isUnhandledSecurityGroup = (securityGroup) =>
  typeof securityGroup === "string" &&
  securityGroup.startsWith(REFLOW_CONNECT_SG_PREFIX) &&
  !SUPPORTED_SECURITY_GROUP_IDS.includes(securityGroup);

// Security groups with restricted access to the Settings page (route blocked + nav icon hidden).
export const RESTRICTED_SECURITY_GROUP_IDS = [
  OPERATIONS_SECURITY_GROUP_ID,
  ACCOUNTING_SECURITY_GROUP_ID,
];

// Security groups limited to the Reporting (Statistics) tab only. When one of
// these is the selected security group, every other nav item is hidden and any
// route outside REPORTING_ONLY_ALLOWED_SECTION is redirected there by the auth guard.
export const REPORTING_ONLY_SECURITY_GROUP_IDS = [REPORTING_SECURITY_GROUP_ID];

// The single route section (/<locale>/<section>) a reporting-only security group may access.
export const REPORTING_ONLY_ALLOWED_SECTION = "statistics";

// Controls the display order of security groups in the select-security-group dropdown.
// Groups not listed here keep the order the backend returns them in, after the ones listed.
export const SECURITY_GROUP_DISPLAY_ORDER = [
  ACCOUNTING_SECURITY_GROUP_ID,
  OPERATIONS_SECURITY_GROUP_ID,
  ADMINISTRATOR_SECURITY_GROUP_ID,
  REPORTING_SECURITY_GROUP_ID,
  STORE_MANAGER_SECURITY_GROUP_ID,
];

// Maps a raw security group id to its translation key for a friendly display label.
export const SECURITY_GROUP_LABELS = {
  [ACCOUNTING_SECURITY_GROUP_ID]: "accountingSecurityGroup",
  [OPERATIONS_SECURITY_GROUP_ID]: "operationsSecurityGroup",
  [ADMINISTRATOR_SECURITY_GROUP_ID]: "administratorSecurityGroup",
  [REPORTING_SECURITY_GROUP_ID]: "reportingSecurityGroup",
  [STORE_MANAGER_SECURITY_GROUP_ID]: "storeManagerSecurityGroup",
};

export const QUERY_KEYS = {
  ITEM_CONDITIONS: "itemConditions",
  DISCOUNT_PROFILES_BY_PRODUCT_ID: "discountProfilesByProductId",
  EASY_LISTER_DATA: "easy-lister-data",
  SHIPPING_COSTS: "shipping-costs",
};
export const PAYMENT_STATUS = {
  PAID: "Paid",
};
export const HANDLING_TYPE_TO_SHIPPING_TYPE = {
  [SHIPPING_HANDLING_TYPES.TWO_MH]: "FLAT",
  [SHIPPING_HANDLING_TYPES.PARCEL]: "FLAT",
  [SHIPPING_HANDLING_TYPES.NULL]: "FLAT",
};
export const SHIPPING_METHOD = {
  FLAT: "DE_DHLPaket",
  FREIGHT_FLAT: "DE_DHLPaket",
};
export const HANDLING_TYPE_TO_SHIPPING_METHOD = {
  [SHIPPING_HANDLING_TYPES.TWO_MH]: "DE_DHLPaket",
  [SHIPPING_HANDLING_TYPES.PARCEL]: "DE_DHLPaket",
};
export const ASSORTMENT_FLAGS = {
  OA: "OA",
  OUT: "OUT",
  EOL: "EOL",
  PRO: "PRO",
};

export const PATH_NAMES = {
  ORDERS: "orders",
  LISTINGS: "listings",
  RETURNS: "returns",
  OUTLETS: "outlets",
  RANKINGS: "rankings",
  SELLER_LIMITS: "sellerLimits",
  FAILED_MIRAKL_LISTINGS: "failedMiraklListings",
};

export const PROCESSING_TIME_VALUES = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
];

export const STATS_KEYS = {
  TOTAL_ONLINE_EBAY_ITEM_COUNT: "totalOnlineEbayItemCount",
  TOTAL_ONLINE_MIRAKL_ITEM_COUNT: "totalOnlineMiraklItemCount",
  EBAY_ORDERS_COMPLETED_COUNT: "ebayOrdersCompletedCount",
  MIRAKL_ORDERS_COMPLETED_COUNT: "miraklOrdersCompletedCount",
  TOTAL_EBAY_ORDER_SALES_PRICE: "totalEbayOrderSalesPrice",
  TOTAL_EBAY_RETURN_COMPLETED_COUNT: "totalEbayReturnCompletedCount",
  TOTAL_MIRAKL_RETURN_COMPLETED_COUNT: "totalMiraklReturnCompletedCount",
  TOTAL_EBAY_RETURN_PERCENTAGE: "totalEbayReturnPercentage",
  TOTAL_MIRAKL_RETURN_PERCENTAGE: "totalMiraklReturnPercentage",
  TOTAL_MIRAKL_ORDER_SALES_PRICE: "totalMiraklOrderSalesPrice",
};

export const HREFS = {
  LISTING_OVERVIEW_HREF: "listings/overview/?marketplace=ebay&condition=all",
  MIRAKL_LISTING_OVERVIEW_HREF:
    "listings/overview/?marketplace=mirakl&condition=all",
  RETURNS_LISTING_HREF: "returns/return-listing/?status=CLOSED",
  EBAY_RETURNS_LISTING_HREF: "returns/return-listing/?status=COMPLETED",
  ORDERS_LISTING_HREF:
    "orders/order-listing/?ebayOrderFilterType=COMPLETED_ORDERS",
};

export const SEARCH_PARAMS = {
  EBAY_ORDER_FILTER_TYPE: "ebayOrderFilterType",
};

export const HOVER_EFFECT = {
  HOVER_GRAY: "hover:shadow-[0_0_16px_#DADADA]",
  SHADOW_GRAY: "shadow-[0_0_16px_#DADADA]",
};

export const INVALID_SHIPPING_TIMES = [10, 15, 20];

export const RANKING_TYPES = {
  NATIONAL: "national",
  REGIONAL: "regional",
};

export const RANKING_VALUE_HEADERS = {
  REVENUE: "revenue",
  ORDERS: "orders",
  ARTICLES_ONLINE: "articlesOnline",
};

export const METRIC_KEYS = {
  ARTIKEL_ONLINE: "artikelOnline",
  UMSATZ_GESAMT: "umsatzGesamt",
  BESTELLUNGEN_GESAMT: "bestellungenGesamt",
  UMSATZ_PRO_BESTELLUNG: "umsatzProBestellung",
  UMSATZ_LETZTE_KW: "umsatzLetzteKw",
  UMSATZ_AKTUELLE_KW: "umsatzAktuelleKw",
  BESTELLUNGEN_LETZTE_KW: "bestellungenLetzteKw",
  BESTELLUNGEN_AKT_KW: "bestellungenAktKw",
  UMSATZ_AKTUELLER_MONAT: "umsatzAktuellerMonat",
  UMSATZ_LETZTER_MONAT: "umsatzLetzterMonat",
};

export const TEXT_REPLACEMENTS = {
  LINK_REMOVED: "link entfernt",
};

export const HAS_SEARCH = true;

export const ORDER_STATUS_DISPLAY_TO_INTERNAL = {
  Verschickt: "TRACKING_SUCCESS",
  Versandfertig: "READY_TO_SHIP",
  Abgeholt: "PICKED_UP",
  "Versandlabel erstellt": "SHIPPING_LABEL_CREATED",
  Abgebrochen: "CANCELLED",
  Abgeschlossen: "COMPLETED",
  Storniert: "CANCELED",
  "Extern bearbeitet": "EXTERNALLY_HANDLED",
  "Belegnummer fehlt": "ORDER_RECEIPT_MISSING",
  "Warte auf Abholung": "WAITING_FOR_PICKUP",
  "Bestellung angenommen": "ORDER_ACCEPTED",
  "Käufer Storniert": "BUYER_CANCELED",
  Clubnummer: "CLUB_NUMBER_COLLECTED",
  "Rechnungsbeleg erstellt": "INVOICE_RECEIPT_CREATED",
  "Beleg kassiert": "RECEIPT_COLLECTED",
  "Trackingnummer fehlgeschlagen": "TRACKING_FAILED",
  "Tracking Code Added": "TRACKING_CODE_ADDED",
  "Trackingnummer hinzugefügt": "TRACKING_CODE_ADDED",
  "Rechnung hochgeladen": "RECEIPT_BILL_COLLECTED",
};

export const ORDER_STATUS_VALUES = {
  ORDER_STATUS: "orderStatus",
};

export const SHIPPED_TIME_FILTER = {
  FIELD_NAME: "shippedTime",
  YES: "true",
  NO: "false",
};

export const PRICE_CHANGE_TIME = {
  REFERENCE_TIME: 1776948884139,
};

export const API_FILTER_DTO_STATUSES = {
  ALL: "all",
  CLOSED: "closed",
};

export const ACTIVE_STAT_CONDITIONS = {
  EBAY_CONDITION: "ebayCondition",
  MIRAKL_CONDITION: "miraklCondition",
  MARKETPLACE: "marketplace",
  CONDITION: "condition",
};

export const STATS_ORDER = [
  "allEbayOrders",
  "notAcceptedOrderCounts",
  "documentNotCreatedForOrderCounts",
  "documentNotCollectedForOrderCounts",
  "orderReceiptMissingOrderCounts",
  "shippingLabelNotUploadOrderCounts",
  "readyForDispatchOrderCounts",
  "completedOrderCounts",
  "uploadBillOrderCounts",
  "uploadInvoiceBillOrderCounts",
  "receiptUploadOrderCounts",
  "receiptBillUploadOrderCounts",
  "allMiraklOrders",
  "miraklAwaitingShipmentOrderCounts",
  "allDueOrders",
  "canceledOrderCounts",
];

export const EBAY_MESSAGE_FILTER_FIELDS = {
  READ: "read",
};

export const EBAY_MESSAGE_FILTER_VALUES = {
  UNREAD: "false",
};

export const LOGISTICS_CLASS = {
  DHL: [1, 2, 3, 4, 7, 11],
  FREIGHT: [5, 6, 8, 14, 16, 17],
};
